import { render, staticRenderFns } from "./mallHome.vue?vue&type=template&id=5639135c&scoped=true"
import script from "./mallHome.vue?vue&type=script&lang=js"
export * from "./mallHome.vue?vue&type=script&lang=js"
import style0 from "./mallHome.vue?vue&type=style&index=0&id=5639135c&prod&lang=less&scoped=true"
import style1 from "./mallHome.vue?vue&type=style&index=1&id=5639135c&prod&scoped=true&lang=less"
import style2 from "./mallHome.vue?vue&type=style&index=2&id=5639135c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5639135c",
  null
  
)

export default component.exports